import { Record } from 'immutable';

/*
 * 1 & 2) accountId and id return the same string, that string being the accountid
 *
 * 3) The accountName is self explanatory
 *
 * 4) dailyPerformance returns a list of objects with properties 'performance' and 'performanceOn'. This lists
 *   all the dates within the specified dateRange and the data for each date. NOTE: If there is no data for
 *   a date, QCS does not include this date in the list. So if the dateRange is set to January of 2018 where no data exists,
 *   the list will simply start from the earliest available date. Note that the first date will always be 0% as it acts as the
 *   baseline comparison for all the other dates.
 *
 * 5) totalPerformance contains the performance percent difference between the first date in dailyPerformance and the final date
 *   in dailyPerformance.
 *
 * 6 & 7) startOn and endOn are NOT the dateranges you passed to QCS. They represent the first and last dates
 *       that QCS conjured up in dailyPerformances
 *
 * 8) todayPerformance is used to calculate the change from yesterday to today. It is an object that contains
 *   'performance' and 'performanceOn'. This one is calculated by first checking to see if there is data for Todays' Date
 *   (Todays' data is not calculated until the end of the trading day, OR if it is a manual account, it is calculated whenever
 *   a holding is editing in that manual account). If there is no data, 'performance' will be 0% because on the client end, we
 *   automatically fill in empty dates with the data from the day before. If there IS data for today, we compare the performances
 *   from yesterday to today, and make THAT 'performance'.
 *
 * 9 and 10) startBalance and endBalance are simply the balances on the startOn and endOn dates.
 *
 * 11) amountChange is the difference between the startBalance and endBalance
 *
 * */

export const mkInvestmentTWRR = Record({
  accountId: undefined,
  id: undefined,
  accountName: undefined,
  dailyPerformance: undefined,
  totalPerformance: undefined,
  startOn: undefined,
  endOn: undefined,
  todayPerformance: undefined,
  startBalance: undefined,
  endBalance: undefined,
  amountChange: undefined,
  status: undefined,
});
